module.exports = __webpack_public_path__ + "static/wylogo-878dfeedc2437a0318989da458897599.png";